export { default as Honeybadger } from '@honeybadger-io/js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DefaultErrorComponent extends Component {
    render() {
        return (jsxs("div", { className: 'error', children: [jsx("div", { children: "An Error Occurred" }), jsx("div", { children: JSON.stringify(this.props.error, null, 2) }), jsx("div", { children: this.props.info ? JSON.stringify(this.props.info, null, 2) : '' })] }));
    }
}
DefaultErrorComponent.propTypes = {
    error: PropTypes.object,
    info: PropTypes.object
};

class HoneybadgerErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            info: null,
            errorOccurred: false
        };
    }
    static getDerivedStateFromError(error) {
        return { error: error, errorOccurred: true, info: null };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ errorOccurred: true, error: error, info: errorInfo });
        this.props.honeybadger.notify(error, { context: errorInfo });
    }
    getErrorComponent() {
        return this.props.ErrorComponent
            ? React.createElement(this.props.ErrorComponent, this.state)
            : jsx(DefaultErrorComponent, { ...this.state });
    }
    render() {
        return (jsx(Fragment, { children: this.state.errorOccurred
                ? this.getErrorComponent()
                : this.props.children }));
    }
}
HoneybadgerErrorBoundary.propTypes = {
    honeybadger: PropTypes.object.isRequired,
    children: PropTypes.element,
    ErrorComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
};

export { HoneybadgerErrorBoundary };
//# sourceMappingURL=honeybadger-react.esm.js.map
